import axios from 'axios'

// В development используем локальный прокси для обхода CORS
const isDevelopment = process.env.NODE_ENV === 'development'
const coingeckoBaseUrl = isDevelopment ? '/api/coingecko' : 'https://api.coingecko.com/api/v3/coins'
const blocksdecodedUrl = 'https://api-markets.moliedev.xyz/v1'

export function getMarketsGlobal() {
  return axios.get(`${blocksdecodedUrl}/global-markets`)
}

export function getMarkets(count = 250) {
  return axios.get(`${blocksdecodedUrl}/coins?order_by_rank=true&limit=${Math.min(count, 250)}`)
}

export function getMarketsByIds(ids) {
  return axios.get(`${coingeckoBaseUrl}/markets?vs_currency=USD&order=market_cap_desc&sparkline=false&price_change_percentage=24h,7d,14d,30d,200d,1y&ids=${ids}`)
}

export function getDefiCoins() {
  return axios.get(`${blocksdecodedUrl}/defi-protocols`)
}

export function getCoinTvlChart(coin, period = '1w') {
  return axios.get(`${blocksdecodedUrl}/defi-protocols/${coin}/tvls?interval=${period}`)
}

export function getCoinVolumeChart(coin) {
  return axios.get(`${coingeckoBaseUrl}/${coin}/market_chart?vs_currency=USD&days=1`)
}

export function getDefiMarkets() {
  return axios.get(`${coingeckoBaseUrl}/markets?vs_currency=USD&order=market_cap_desc&sparkline=false&price_change_percentage=24h,7d,14d,30d,200d,1y&category=decentralized_finance_defi`)
}

export function getCoinInfo(id) {
  return axios.get(`${coingeckoBaseUrl}/${id}?localization=false&tickers=true&&sparkline=true`)
}

export function getNews() {
  const cryptocompareUrl = isDevelopment ? '/api/cryptocompare' : 'https://min-api.cryptocompare.com'
  return axios.get(`${cryptocompareUrl}/data/v2/news/?feeds=cointelegraph,theblock,decrypt&extraParams=Walme&excludeCategories=Sponsored`)
}
